import { render, staticRenderFns } from "./FPotensiSpasialExt.vue?vue&type=template&id=58bd13c7&scoped=true"
import script from "./FPotensiSpasialExt.vue?vue&type=script&lang=js"
export * from "./FPotensiSpasialExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd13c7",
  null
  
)

export default component.exports